







































































































































import Countdown from 'components/Countdown.vue'
import { QForm } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getPasswordColor, getPasswordProgress } from '../helpers/password'

@Component({
  components: { Countdown }
})
export default class ForgotScreen3 extends Vue {
  @Prop({ type: Number }) readonly userId!: number

  @Prop({ type: String, required: true }) readonly method!: string

  emailCode: string = ''

  telCode1: string = ''

  telCode2: string = ''

  password: string = ''

  passwordTest: string = ''

  isHiddenPassword: boolean = true

  countdown: number | null = null

  loading: boolean = false

  errors: Record<string, string[]> = {}

  timer: any = null

  done: boolean = false

  redirectUrl: string | null = null

  get code () {
    if (this.method === 'email') {
      return this.emailCode
    }
    return this.telCode1 + this.telCode2
  }

  get passwordLevel () {
    return getPasswordProgress(this.password)
  }

  get passwordLevelColor () {
    return getPasswordColor(this.passwordLevel)
  }

  get formattedCountdown (): string | null {
    if (!this.countdown) {
      return null
    }
    const countdown = Number(this.countdown)
    const minutes = `0${Math.ceil(countdown / 60)}`.substr(-2, 2)
    const seconds = `0${countdown % 60}`.substr(-2, 2)
    return `${minutes}:${seconds}`
  }

  get challenge () {
    return this.$route.query.login_challenge
  }

  mounted () {
    if (this.$route.query.code) {
      const code =  String(this.$route.query.code)
      if (this.method === 'email') {
        this.emailCode = code
      } else {
        this.telCode1 = code.substr(0, 3)
        this.telCode2 = code.substr(3)
      }
    }

    this.$axios.get('/forgot/recovery-countdown', { params: { userId: this.userId } })
      .then(({ data }) => {
        this.countdown = data.countdown || 0
      })

    clearInterval(this.timer)
    this.timer = setInterval(() => {
      if (this.countdown !== null && this.countdown > 0) {
        this.countdown -= 1
      }
    }, 1000)
  }

  beforeDestroy () {
    clearInterval(this.timer)
  }

  handleTelCode1 (value: string) {
    let formattedValue = value.replace(/\D/g, '')
    let suffix
    if (formattedValue.length > 3) {
      suffix = formattedValue.substr(3)
      formattedValue = formattedValue.substr(0, 3)
    }
    if (suffix) {
      this.handleTelCode2(`${suffix}${this.$refs.telCode2}`)
    }
    this.$nextTick(() => {
      this.telCode1 = formattedValue
    })
    if (formattedValue.length === 3) {
      ((this.$refs.telCode2 as Vue).$refs.input as HTMLInputElement).focus()
    }
  }

  handleTelCode2 (value: string) {
    const formattedValue = value.replace(/\D/g, '').substr(0, 3)
    this.$nextTick(() => {
      this.telCode2 = formattedValue
    })
    if (!formattedValue.length) {
      ((this.$refs.telCode1 as Vue).$refs.input as HTMLInputElement).focus()
    }
  }

  sendMessage () {
    this.loading = true
    this.$axios.post('/forgot/send-recovery-message', { userId: this.userId, method: this.method }, {
      headers: {
        'CSRF-Token': this.$q.cookies.get('xsrf')
      },
      withCredentials: true
    }).then(async ({ data }) => {
      if (data.countdown) {
        this.countdown = data.countdown
      }
      if (data.ok) {
        this.$q.notify({
          message: (this.method === 'tel'
            ? this.$t(this.$msg.SentSms)
            : this.$t(this.$msg.SentEmail)).toString(),
          color: 'positive'
        })
      } else {
        this.$q.notify({
          message: data.errors || this.$t(this.$msg.FatalErrorDefaultMessage).toString(),
          color: 'negative'
        })
      }
      if (data.countdown) {
        this.countdown = Number(data.countdown)
      }
    }).finally(() => {
      this.loading = false
    })
  }

  submitForm () {
    this.errors = {};
    (this.$refs.resetPasswordForm as QForm).validate().then((success) => {
      if (success) {
        const csrfToken = this.$q.cookies.get('xsrf')
        const { code, password } = this
        const formData = {
          userId: this.userId,
          code,
          password,
          challenge: this.challenge,
          _csrf: csrfToken
        }
        const headers = { 'CSRF-Token': csrfToken }

        this.loading = true
        this.$axios.post('/forgot/reset-password', formData, { headers: headers, withCredentials: true })
          .then(async ({ data }) => {
            if (data.ok) {
              this.errors = {};
              (this.$refs.resetPasswordForm as QForm).resetValidation()
              this.redirectUrl = data.redirectUrl || null
              this.done = true
            } else if (data.errors) {
              if (data.errors.code || data.errors.password) {
                this.errors = data.errors
                await (this.$refs.resetPasswordForm as QForm).validate()
              } else {
                const errors = Object.values(data.errors).shift() as string[]
                this.$q.notify({
                  message: errors[0],
                  color: 'negative',
                  position: 'top'
                })
              }
            }
          }).catch((e) => {
          this.errors = {
            network: e.message
          }
        }).finally(() => {
          this.loading = false
        })
      }
    })
  }
}
